import React from 'react';
import { flatten } from 'ramda';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { legShape, productsShape } from 'constants/propTypes';
import Table from 'components/ui/Table';
import Leg from 'components/shared/Leg';

import { colours } from 'themes/default';

const JourneySegment = ({
  bookingReference,
  journey,
  journey: { direction, serviceType, ticketDocuments = [] },
  currency,
  formatHeader,
  bookingItems,
  numberOfPassengers,
  numberOfActivePassengers,
  includeFareConditions,
  columns,
  buildRow,
  cancelledLoyaltyItems = [],
  withExchangedProducts,
  status
}) => {
  const items = bookingItems || journey.bookingItems;

  const isAlreadyExchangedLoyalty = items.some(({ itemRef }) => cancelledLoyaltyItems.includes(itemRef));
  const [firstCurrentOverride] = flatten(items.map((item) => (item.cancelled ? [] : item.afterSalesCurrentOverrides || [])));

  const loyaltyExchanged = isAlreadyExchangedLoyalty ? { reasonCode: 'LOYALTY EXCHANGED' } : undefined;
  const afterSaleRuleOverride = firstCurrentOverride || loyaltyExchanged;

  return (
    <Leg
      status={status}
      bookingReference={bookingReference}
      direction={direction}
      serviceType={serviceType}
      trainNumber={journey.trainNumber}
      numberOfPassengers={numberOfPassengers}
      numberOfActivePassengers={numberOfActivePassengers}
      origin={journey.origin}
      destination={journey.destination}
      departureTime={journey.timing.departs}
      arrivalTime={journey.timing.arrives}
      classOfService={journey.classOfService}
      includeFareConditions={includeFareConditions}
      afterSaleRuleOverride={afterSaleRuleOverride}
      customerTransactionRef={ticketDocuments[0] && ticketDocuments[0].pin}
      date={journey.timing.isoDate}
      currency={currency}
      journey={journey}
      withExchangedProducts={withExchangedProducts}
    >
      <Table
        borderColor={colours.Greyscale.Black}
        headerColor={colours.Greyscale.Black}
        headerBackground={colours.Greyscale.White}
        formatHeader={formatHeader}
        columns={columns}
        rows={items.map((item, i) => buildRow(item, i, journey))}
      />
    </Leg>
  );
};
JourneySegment.propTypes = {
  numberOfPassengers: PropTypes.number,
  numberOfActivePassengers: PropTypes.number,
  includeFareConditions: PropTypes.bool,
  bookingItems: productsShape,
  currency: PropTypes.string.isRequired,
  formatHeader: PropTypes.func,
  journey: legShape,
  buildRow: PropTypes.func.isRequired,
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      format: PropTypes.func
    })
  ),
  cancelledLoyaltyItems: PropTypes.arrayOf(PropTypes.string),
  withExchangedProducts: PropTypes.arrayOf(
    PropTypes.shape({
      products: productsShape
    })
  ),
  bookingReference: PropTypes.string.isRequired,
  status: PropTypes.string
};

JourneySegment.defaultProps = {
  // eslint-disable-next-line react/prop-types
  formatHeader: ({ key }) => <FormattedMessage id={`journeySegment.${key}`} />
};

export default JourneySegment;
